import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import queryString from "query-string";

import ScheduleList from "./_list";
import DateRange from "../../Components/DateRange";
import { encodeBody } from "../../BackendClient";
import DateFormat from "../../helpers/DateFormat";

const mapStateToProps = ({ identity }) => ({
  identity
});

class Schedule extends Component {
  state = {
    cities: null,
    theatres: null,
    sort: ["film.title", true],
    filters: {}
  };

  componentDidUpdate() {
    const { theatre, dateBegin, dateEnd } = queryString.parse(
      this.props.location.search,
      {
        decode: true,
        arrayFormat: "none"
      }
    );

    let { filters: stateFilters } = this.state;
    const parsedFilters = {};

    if (theatre) {
      stateFilters.theatre !== theatre &&
        Object.assign(parsedFilters, { theatre });
    }
    //  else if (stateFilters.theatre) {
    //   Object.assign(parsedFilters, { theatre: null });
    // }

    if (dateBegin) {
      if (
        !stateFilters.dateBegin ||
        DateFormat.ddmmyyyy(stateFilters.dateBegin) !== dateBegin
      ) {
        const dtBegin = this.strToDate(dateBegin);
        dtBegin && Object.assign(parsedFilters, { dateBegin: dtBegin });
      }
    } else if (stateFilters.dateBegin) {
      Object.assign(parsedFilters, { dateBegin: null });
    }
    if (dateEnd) {
      if (
        !stateFilters.dateEnd ||
        DateFormat.ddmmyyyy(stateFilters.dateEnd) !== dateEnd
      ) {
        const dtEnd = this.strToDate(dateEnd);
        dtEnd && Object.assign(parsedFilters, { dateEnd: dtEnd });
      }
    } else if (stateFilters.dateEnd) {
      Object.assign(parsedFilters, { dateEnd: null });
    }

    const hasNewFilters = !!Object.entries(parsedFilters).length;
    const filters = hasNewFilters
      ? Object.assign(stateFilters, parsedFilters)
      : stateFilters;

    if (hasNewFilters) {
      this.setState({ filters });
    }
  }

  componentDidMount() {
    const { dateBegin, dateEnd } = queryString.parse(
      this.props.location.search,
      {
        decode: true,
        arrayFormat: "none"
      }
    );
    const { theatreId } = this.props.identity;

    if (theatreId) {
      this.updateLink({ theatre: theatreId, dateBegin, dateEnd });
    }
  }

  strToDate = str => {
    let pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
    return new Date(str.replace(pattern, "$3-$2-$1"));
  };

  dateRangeFilterOnChange = ({ startDate, endDate }) => {
    this.updateLink({
      dateBegin: DateFormat.ddmmyyyy(startDate),
      dateEnd: DateFormat.ddmmyyyy(endDate)
    });
  };

  cityFilterOnChange = city => {
    this.updateLink({ city: (city && city.value) || null, theatre: null });
    this.setState({ theatres: null });
  };

  theatreFilterOnChange = theatre => {
    this.updateLink({ theatre: (theatre && theatre.value) || null });
  };

  updateLink(newParams) {
    const filters = Object.assign({}, this.state.filters);
    const params = Object.assign(filters, newParams);
    const body = Object.entries(params).reduce(
      (prev, [key, value]) =>
        (value && Object.assign(prev, { [key]: value })) || prev,
      {}
    );
    const stringParams = encodeBody(body);
    this.props.history.push(`schedule${stringParams && "?" + stringParams}`);
  }

  getRange() {
    let {
      filters: { dateBegin, dateEnd }
    } = this.state;
    if (dateBegin && dateEnd) {
      return { dateBegin, dateEnd };
    }
    return {
      dateBegin: new Date(2018, 4, 1),
      dateEnd: new Date(2018, 4, 7)
    };
  }

  getDates() {
    const { dateBegin, dateEnd } = this.getRange();
    const range = [];
    range.push(dateBegin.getTime());
    range.push(dateEnd.getTime());
    return range;
  }

  renderFilters() {
    const dates = this.getDates();

    return (
      <div className="filterSchedules">
        <div className="office-filters">
          <div className="office-filters__half custom-datepicker__group">
            <label
              htmlFor="session-datepicker"
              className="custom-datepicker__label"
            >
              День начала/окончания
            </label>
            {
              <DateRange
                input
                dateBegin={(dates[0] && new Date(dates[0])) || null}
                dateEnd={(dates[1] && new Date(dates[1])) || null}
                onChange={this.dateRangeFilterOnChange}
                className="custom-datepicker__input"
              />
            }
            {
              <img
                src="/images/icon-calendar.png"
                alt=""
                className="custom-datepicker__icon"
              />
            }
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      filters: { theatre }
    } = this.state;
    const { dateBegin, dateEnd } = this.getRange();
    let content = "";
    if (dateBegin && dateEnd && theatre) {
      content = (
        <ScheduleList
          dateBegin={dateBegin}
          dateEnd={dateEnd}
          theatreId={theatre}
          canBeDelete={false}
        />
      );
    }
    return (
      <Fragment>
        <h1 className="office-h1">Загрузка расписания</h1>
        <div className="office__schedule-upload">
          <Link to="/schedule/create-schedule" className="btn-gradient">
            Добавить сеанс
          </Link>
          {this.renderFilters()}
          {content}
        </div>
      </Fragment>
    );
  }
}
export default withRouter(connect(mapStateToProps)(Schedule));



// WEBPACK FOOTER //
// ./src/containers/schedule/single.jsx